import {SupportedLocales} from '#types/locale.js';

export const chatMessagesLanguage = {
  [SupportedLocales.EN]: {
    navigation: {
      backToConversations: 'Back to recent conversations',
    },
    chatInput: {
      loadingGoals: 'Loading...',
      errorLoadingGoals: 'Error loading goals',
      addGoals: '@ Add Goals',
      loadingContext: 'Loading context...',
      contextUnavailable: 'Context unavailable',
      contextIncluded: 'Context included',
      documentsIncluded: (count: number) =>
        `${count} ${count === 1 ? 'document' : 'documents'} included`,
      noContext: 'No context',
      untitledDocument: 'Untitled document',
      includedContext: 'Included context',
      documents: 'Documents',
      noDocumentsAvailable: 'No documents are currently available.',
    },
    insights: {
      recommendationHeading: '#### Recommendation',
    },
    audience: {
      entryAudienceSize: 'Entry Audience Size:',
    },
    transaction: {
      fetchingContext: 'Fetching chat context…',
      contextReasoningLabel: 'Gathering context',
      reasoningLabel: 'Thinking',
      unableToFetchSteps:
        'Unable to fetch transaction steps. Please try your query again.',
    },
    errors: {
      unableToLoadContextFor:
        'We were unable to load the conversation context for:',
      unableToRetrieveHistoryFor:
        'We were unable to retrieve the chat history for:',
      contextFallback:
        'There was an error loading the conversation context. Please try again later.',
      historyFallback:
        'There was an error retrieving the chat history. Please try again later.',
    },
    recentConversations: {
      title: 'Recent Conversations',
      loading: 'Loading...',
      noMoreConversations: 'No more conversations',
      loadMore: 'Load More',
      unknownError: 'Unknown error',
    },
    toolCalls: {
      label: 'Tool calls',
      sql: 'SQL',
      results: 'Results',
      noResults: 'No results',
    },
    toolDetails: {
      query: 'Query',
      response: 'Response',
      request: 'Request',
      noDetails: 'No details are available for this tool call.',
    },
    activity: {
      working: 'Working...',
      workedForPrefix: 'Worked for',
      usingToolPrefix: 'Using',
      ranToolPrefix: 'Ran',
      toolFailedSuffix: 'failed',
    },
    errorMessages: {
      defaultTitle: 'We were unable to complete your request.',
      defaultMessage: 'Please try again.',
      assistantFailureTitle:
        'The assistant was unable to complete your request.',
      assistantFailureMessage:
        'Something went wrong processing your request. Please try again.',
      agentBusy: 'Wait just a moment; an agent is completing your request...',
      reload: 'Reload',
    },
  },
  [SupportedLocales.ES]: {
    navigation: {
      backToConversations: 'Volver a conversaciones recientes',
    },
    chatInput: {
      loadingGoals: 'Cargando...',
      errorLoadingGoals: 'Error al cargar objetivos',
      addGoals: '@ Agregar objetivos',
      loadingContext: 'Cargando contexto...',
      contextUnavailable: 'Contexto no disponible',
      contextIncluded: 'Contexto incluido',
      documentsIncluded: (count: number) =>
        `${count} ${count === 1 ? 'documento incluido' : 'documentos incluidos'}`,
      noContext: 'Sin contexto',
      untitledDocument: 'Documento sin título',
      includedContext: 'Contexto incluido',
      documents: 'Documentos',
      noDocumentsAvailable: 'No hay documentos disponibles actualmente.',
    },
    insights: {
      recommendationHeading: '#### Recomendación',
    },
    audience: {
      entryAudienceSize: 'Tamaño de audiencia de entrada:',
    },
    transaction: {
      fetchingContext: 'Obteniendo contexto del chat…',
      contextReasoningLabel: 'Recopilando contexto',
      reasoningLabel: 'Pensando',
      unableToFetchSteps:
        'No se pudieron obtener los pasos de la transacción. Por favor intenta tu consulta nuevamente.',
    },
    errors: {
      unableToLoadContextFor:
        'No pudimos cargar el contexto de la conversación para:',
      unableToRetrieveHistoryFor:
        'No pudimos recuperar el historial del chat para:',
      contextFallback:
        'Hubo un error al cargar el contexto de la conversación. Por favor intenta de nuevo más tarde.',
      historyFallback:
        'Hubo un error al recuperar el historial del chat. Por favor intenta de nuevo más tarde.',
    },
    recentConversations: {
      title: 'Conversaciones recientes',
      loading: 'Cargando...',
      noMoreConversations: 'No hay más conversaciones',
      loadMore: 'Cargar más',
      unknownError: 'Error desconocido',
    },
    toolCalls: {
      label: 'Llamadas a herramientas',
      sql: 'SQL',
      results: 'Resultados',
      noResults: 'Sin resultados',
    },
    toolDetails: {
      query: 'Consulta',
      response: 'Respuesta',
      request: 'Solicitud',
      noDetails:
        'No hay detalles disponibles para esta llamada de herramienta.',
    },
    activity: {
      working: 'Trabajando...',
      workedForPrefix: 'Trabajó durante',
      usingToolPrefix: 'Usando',
      ranToolPrefix: 'Ejecutó',
      toolFailedSuffix: 'falló',
    },
    errorMessages: {
      defaultTitle: 'No pudimos completar tu solicitud.',
      defaultMessage: 'Por favor intenta de nuevo.',
      assistantFailureTitle: 'El asistente no pudo completar tu solicitud.',
      assistantFailureMessage:
        'Algo salió mal al procesar tu solicitud. Por favor intenta de nuevo.',
      agentBusy:
        'Espera un momento; un agente está completando tu solicitud...',
      reload: 'Recargar',
    },
  },
};
